import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { Link } from "react-router-dom";
import { api, formatPrice } from "@/lib/api";
import { useCurrency } from "@/context/CurrencyContext";

export default function SearchOverlay({ open, onClose }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const { currency } = useCurrency();

  useEffect(() => {
    if (!open) return;
    if (!q.trim()) { setResults([]); return; }
    const t = setTimeout(async () => {
      setLoading(true);
      try {
        const { data } = await api.get(`/products?search=${encodeURIComponent(q)}&limit=8`);
        setResults(data);
      } finally { setLoading(false); }
    }, 250);
    return () => clearTimeout(t);
  }, [q, open]);

  useEffect(() => { if (!open) setQ(""); }, [open]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-[#FDFBF7]" data-testid="search-overlay">
      <div className="px-6 md:px-12 lg:px-16 pt-24">
        <div className="flex items-center justify-between mb-8">
          <p className="text-[11px] uppercase tracking-nav text-[#5C1A1B]">Search the Atelier</p>
          <button onClick={onClose} data-testid="search-close" aria-label="Close search"><X strokeWidth={1.3} /></button>
        </div>
        <input
          autoFocus
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search lehengas, anarkalis, zardozi…"
          className="w-full bg-transparent border-b border-[#BCA37F]/40 focus:border-[#5C1A1B] font-serif text-4xl md:text-6xl py-4 outline-none placeholder:text-[#BCA37F]/60"
          data-testid="search-input"
        />
        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-8">
          {loading && <p className="text-sm text-[#7A7A7A]">Searching…</p>}
          {!loading && results.map((p) => (
            <Link
              key={p.product_id}
              to={`/product/${p.slug}`}
              onClick={onClose}
              className="group"
              data-testid={`search-result-${p.slug}`}
            >
              <div className="aspect-[3/4] overflow-hidden bg-[#F3EFEA]">
                <img src={p.images[0]} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <p className="font-serif text-lg mt-3">{p.name}</p>
              <p className="text-sm text-[#4A4A4A]">{formatPrice(p.price_inr, currency)}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
